import React from "react";

const styles = `
  .service-notice { padding: 1rem 0; }

  .service-notice__inner {
    display: flex;
    align-items: center;
    gap: 16px;
    background: #042C53;
    border: 0.5px solid #031e3a;
    border-radius: 12px;
    padding: 18px 22px;
    position: relative;
    overflow: hidden;
  }

  .service-notice__inner::after {
    content: '';
    position: absolute;
    top: 0;
    left: -60%;
    width: 45%;
    height: 100%;
    background: linear-gradient(
      120deg,
      transparent 0%,
      rgba(255,255,255,0.03) 40%,
      rgba(255,255,255,0.09) 50%,
      rgba(255,255,255,0.03) 60%,
      transparent 100%
    );
    animation: shine 3.2s ease-in-out infinite;
    pointer-events: none;
  }

  @keyframes shine {
    0%   { left: -60%; }
    60%  { left: 110%; }
    100% { left: 110%; }
  }

  .service-notice__icon {
    flex-shrink: 0;
    align-self: flex-start;
    margin-top: 2px;
  }

  .service-notice__content { flex: 1; min-width: 0; }

  .service-notice__label {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.08em;
    color: rgba(255,255,255,0.55);
    margin-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .service-notice__dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #ffffff;
    flex-shrink: 0;
    animation: pulse 2s ease-in-out infinite;
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0.3; }
  }

  .service-notice__text {
    font-size: 13.5px;
    line-height: 1.65;
    color: #ffffff;
    margin: 0;
  }

  .service-notice__badge {
    flex-shrink: 0;
    text-align: center;
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.07em;
    line-height: 1.4;
    padding: 8px 14px;
    border-radius: 8px;
    background: rgba(255,255,255,0.08);
    color: #ffffff;
    border: 0.5px solid rgba(255,255,255,0.25);
    white-space: nowrap;
    align-self: center;
    animation: badgeblink 2.4s ease-in-out infinite;
  }

  @keyframes badgeblink {
    0%, 100% { background: rgba(255,255,255,0.08); border-color: rgba(255,255,255,0.25); }
    50%       { background: rgba(255,255,255,0.2);  border-color: rgba(255,255,255,0.5); }
  }
`;

export default function ServiceNotice() {
  return (
    <>
      <style>{styles}</style>
      <section className="service-notice">
        <div className="service-notice__inner">

          <div className="service-notice__icon">
            <svg
              width="38"
              height="38"
              viewBox="0 0 48 48"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <rect x="2" y="2" width="44" height="44" rx="12"
                stroke="rgba(255,255,255,0.7)" strokeWidth="1.8" />
              <circle cx="24" cy="16" r="2.2" fill="rgba(255,255,255,0.9)" />
              <line x1="24" y1="22" x2="24" y2="34"
                stroke="rgba(255,255,255,0.9)" strokeWidth="2.2" strokeLinecap="round" />
            </svg>
          </div>

          <div className="service-notice__content">
            <div className="service-notice__label">
              <span className="service-notice__dot"></span>
              SERVICE INFORMATION
            </div>
            <p className="service-notice__text">
              We provide Innovation Lab setup support, including equipment and
              material supply, installation, configuration, commissioning, and
              operational guidance for schools and institutions. To ensure
              effective utilization and long-term sustainability of the lab, a
              mandatory 3–5 year training collaboration agreement is required
              with a minimum yearly student strength of 200. While the
              institution provides the necessary infrastructure and lab space,
              our team ensures continuous training support, innovation
              activities, and technical guidance throughout the partnership.
            </p>
          </div>

          <div className="service-notice__badge">
            ASSURED<br />PARTNERSHIP
          </div>

        </div>
      </section>
    </>
  );
} 